import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Spinner, TypographyStyle } from '@treelab/panda';

import { Typography } from '../../Typography';
import { Container } from './styled';

const ModalPrintLoading: React.FC = () => (
  <Container>
    <Spinner></Spinner>
    <Typography type={TypographyStyle.P1} style={{ marginTop: '18px' }}>
      <FormattedMessage id="print.loading" />
    </Typography>
  </Container>
);

export default ModalPrintLoading;
